<template>
  <div class="">
    <div class="card">
      <div class="card-body nopadding">
        <h5 class="card-title  text-black mt-3">
          <b>¿Cómo deseas recogerlo?</b>
        </h5>
        <div class="row">
          <div class="col-12 col-md-4 col-sm-6 col-lg-3">
            <h6 class="text-black  ">Has seleccionado:</h6>
          </div>
          <div class="col-12 col-md-8 col-sm-6 col-lg-9">
            <b class="text-turkey text-left " style="font-size:15px">
              {{ dia_select }} {{ hora_selec }}</b
            >
            <br />
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-1 col-2"
            style="padding-right: 1px !important;padding-left: 0px !important"
          >
            <button
              style="z-index:500000"
              class="mt-5 btn-chevron"
              @click="nextDias(false, 'left')"
              :disabled="
                (flag == 3 && window > 769) || (flag == 1 && window <= 769)
              "
            >
              <v-icon
                :class="{
                  'text-black':
                    (flag !== 3 && window > 769) ||
                    (flag !== 1 && window <= 769)
                }"
                name="chevron-left"
                id="chevron-left"
              ></v-icon>
            </button>
          </div>
          <div class="col-md-10 col-8 p-3" style="padding: 0px !important">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col" class="static">
                      <div class="card  noBorder bg-white text-center card2">
                        <div class="card-body nopadding ">
                          <h5
                            class="card-title text-transparente font-weight-light subtittle"
                          ></h5>
                          <h6 class="text-transparente"></h6>
                          <h6 class="text-transparente"></h6>
                        </div>
                      </div>
                    </th>
                    <th
                      v-for="(dia, index) of ViewDias"
                      scope="col"
                      :key="index"
                      :class="{
                        'first-col': index === 0
                      }"
                    >
                      <div class="card22 card bg-dark text-center ">
                        <div class="card-body nopadding">
                          <h5
                            class="card-title text-white font-weight-light subtittle"
                          ></h5>
                          <h6 class="text-white">{{ dia.nombre }}</h6>
                          <h6 class="text-white">
                            {{ dia.dia }} {{ GET_MOUNTH_ACCOUNT }}
                          </h6>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(horario, index1) of $store.state.calendario.horario"
                    :key="index1"
                  >
                    <td scope="row" class="text-horario static">
                      {{ horario.data.desc }}
                    </td>
                    <td
                      v-for="(dia, index2) of ViewDias"
                      :key="index2"
                      :class="{ 'first-col2': index2 === 0 }"
                    >
                      <button
                        type="button"
                        class="btn  btn-outline-secondary"
                        @click="
                          isSelectHora(
                            index1,
                            index2,
                            horario.id,
                            horario.data.desc,
                            dia,
                            $store.state.calendario.dia_detalle[index2].data[
                              index1
                            ],
                            $store.state.calendario.aforoxdia[index2].id
                          )
                        "
                        :class="{
                          activaBtnVerde:
                            btn_select && index1 == i1 && index2 == i2,
                          'border-rosado':
                            $store.state.calendario.dia_detalle[index2].data[
                              index1
                            ].aforo === '0',
                          'border-verde':
                            $store.state.calendario.dia_detalle[index2].data[
                              index1
                            ].aforo !== '0'
                        }"
                        :disabled="
                          $store.state.calendario.dia_detalle[index2].data[
                            index1
                          ].aforo === '0'
                            ? true
                            : false
                        "
                      >
                        <div v-if="$store.state.calendario.loading2 === false">
                          {{
                            $store.state.calendario.dia_detalle[index2].data[
                              index1
                            ].aforo === "0"
                              ? "No disponible"
                              : "Disponible"
                          }}
                        </div>
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          v-if="$store.state.calendario.loading2 === true"
                        ></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <!-- {{ $store.state.calendario.dia_detalle[0].data[0].id_horario }} -->
          </div>
          <div class="col-md-1 col-2 " style="padding-left: 0 !important">
            <button
              class="mt-5 btn-chevron"
              :disabled="
                (flag == 6 && window > 769) || (flag == 4 && window <= 769)
              "
              @click="nextDias(false, 'right')"
            >
              <v-icon
                :class="{
                  'text-black':
                    (flag !== 6 && window > 769) ||
                    (flag !== 4 && window <= 769)
                }"
                name="chevron-right"
                id="chevron-right"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["window"],
  data() {
    return {
      i1: null,
      i2: null,
      btn_select: false,
      name: "",
      diaSiguiente: 0,
      flag: 0,
      ViewDias: [],
      apellido: "",
      isVisibleDetalle: false,
      mes2: [],
      nuevoMes: [],
      hora_selec: "",
      dia_select: "",
      isSelectHoraColor: false
    };
  },
  methods: {
    // ============================
    //   GET MES
    //  ===========================
    GET_MESxDIAS() {
      let aux = [];
      let fecha = new Date();
      let yearActual = fecha.getFullYear();
      let mesActual = fecha.getMonth() + 1;
      let dias = new Date(
        fecha.getFullYear(),
        fecha.getMonth() + 1,
        0
      ).getDate();
      const diaActual = new Date().getDate();
      if (dias == diaActual) {
        this.diaSiguiente = 1;
        mesActual = fecha.getMonth() + 2;
        dias = new Date(fecha.getFullYear(), mesActual, 0).getDate();
      }
      //console.log("la fecha actual es ", yearActual, mesActual, dias);
      for (let index = 1; index <= dias; index++) {
        aux.push({
          nombre: this.GET_DIA_NOMBRE(yearActual, mesActual, index),
          dia: index,
          disponible: false,
          cant: 0
        });
      }
      this.mes2 = aux;
      this.GET_MES_ACTIVE();
    },
    GET_DIA_NOMBRE(yearActual, mesActual, dia) {
      const semana = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado"
      ];
      let diaNumber = new Date(
        `${yearActual}/${mesActual}/${dia},12:00:00`
      ).getDay();
      for (let index = 0; index < semana.length; index++) {
        if (diaNumber === index) {
          return semana[index];
        }
      }
    },

    // ============================
    //   GET MES A PARTIR DE HOY
    //  ===========================
    GET_MES_ACTIVE() {
      //console.log("get mes acive");
      let diaActual = new Date().getDate();
      let siguiente = diaActual + 1;
      //console.log(this.diaSiguiente)
      if (this.diaSiguiente !== 0) {
        //console.log("dentro del if")
        siguiente = this.diaSiguiente;
      }
      //console.log("dia a buscar sigueinte",siguiente)
      let cont = 0;
      for (let index = 0; index < this.mes2.length; index++) {
        //console.log("antes del camvbio", this.mes2[index]);
        // //console.log(typeof diaActual);
        if (index + 1 >= siguiente && cont <= 3) {
          //  const aux = Object.assign(this.mes2[index], {disponible:true, cant:0});
          this.mes2[index].disponible = true;
          this.nuevoMes.push(this.mes2[index]);
          cont++;
        }
      }
      //console.log("nuevo mes active", this.nuevoMes);
      this.nextDias(true);
    },
    isSelectHora(index1, index2, id_horario, value, dia, id, id_aforoxdia) {
      try {
        this.btn_select = true;
        this.isSelectHoraColor = true;
        this.i1 = index1;
        this.i2 = index2;
        this.hora_selec = value;
        //console.log("el dia seleccionado es:", dia);
        const diaNumero = dia.dia;
        const diaNombre = dia.nombre;
        const mes = this.GET_MOUNTH_ACCOUNT;
        const FECHA_SELECT =
          diaNombre + " " + diaNumero.toString() + " de " + mes + " de ";
        this.dia_select = FECHA_SELECT;
        this.$store.dispatch("calendario/diaSeleccionado", {
          fecha: FECHA_SELECT,
          dia: `${diaNombre} ${diaNumero}`,
          hora: value,
          id: id,
          id_hora: id_horario,
          id_aforoxdia: id_aforoxdia
        });
      } catch (error) {
        console.log("este es el error", error);
      }
    },
    nextDias(booleano, direccion) {
      let nuevoMes = this.nuevoMes;
      //console.log("nuevo mes ", nuevoMes);
      //console.log("nuevo mes es :", nuevoMes);
      let aux = [];
      for (let index = 0; index < nuevoMes.length; index++) {
        if (nuevoMes[index].disponible === true) {
          aux.push({
            nombre: nuevoMes[index].nombre,
            dia: nuevoMes[index].dia,
            disponible: nuevoMes[index].disponible,
            cant: nuevoMes[index].cant
          });
          //console.log( nuevoMes[index].nombre)
        }
      }
      //console.log("AUX ES :", aux);
      if (booleano) {
        ////console.log("tipo window", typeof this.window);
        if (this.window <= 769) {
          for (let index = 0; index < 1; index++) {
            this.ViewDias.push(aux[index]);
          }
          this.flag = 1;
        } else if (this.window > 769) {
          for (let index = 0; index < 3; index++) {
            this.ViewDias.push(aux[index]);
          }
          this.flag = 3;
        }
      } else if (booleano === false) {
        let aumento = 0;
        if (this.window <= 769) {
          aumento = 1;
        } else {
          aumento = 3;
        }
        //console.log("el aumento es: ", aumento);
        if (direccion === "right" && this.flag < aux.length) {
          let aux2 = [];
          let bandera = this.flag;
          for (let index = bandera; index < bandera + aumento; index++) {
            //console.log("el index ", index);
            if (index < aux.length) {
              //console.log("valor a guardar ", aux[index]);
              aux2.push(aux[index]);
            }
          }
          this.ViewDias = aux2;
          this.flag += aumento;
        } else if (direccion === "left" && this.flag > aumento) {
          let aux2 = [];
          let bandera = this.flag;
          // //console.log("estoy en left");
          // //console.log("el aumeto es ",aumento);
          for (let index = bandera - aumento; index > 0; index--) {
            // //console.log("el index dsdsd", index);
            console.log(index);

            //    //console.log("valor a guardar ", aux[index]);
            aux2.push(aux[index - 1]);
          }
          console.log("----------");
          this.ViewDias = aux2;
          this.flag -= aumento;
        }
      } else {
        alert("No hay mas dias");
      }
    }
  },
  computed: {
    GET_MOUNTH_ACCOUNT() {
      const monthNames = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Deciembre"
      ];

      const d = new Date();
      return monthNames[d.getMonth()];
    }
  },
  mounted() {},
  created() {
    this.GET_MESxDIAS();
  },
  beforeDestroy() {
    //window.removeEventListener("resize", this.getWindowWidth);
  }
};
</script>

<style>
.btn-chevron:focus {
  outline: 0 !important;
}
.icon {
  color: #666;
  width: 2rem;
  height: 3rem;
}
table {
  display: block;
  overflow-x: auto;
}
.table thead th {
  border-bottom: 2px solid #ffffff !important;
}
.noBorder {
  box-shadow: none !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: white !important;
  border: none !important;
}
.card22 {
  border-radius: 20px !important;
}
.card {
  border-radius: 10px;
  -webkit-box-shadow: 10px 10px 55px -18px rgba(0, 0, 0, 0.35);
  -moz-box-shadow: 10px 10px 55px -18px rgba(0, 0, 0, 0.35);
  box-shadow: 10px 10px 55px -18px rgba(0, 0, 0, 0.35);
}
button {
  border-width: 0;
  border-style: none;
  border-color: white;
  border-image: initial;
  background-color: transparent;
}
.text-transparente {
  color: transparent !important;
}
.static {
  z-index: 100;
  position: absolute;
  background-color: white !important;

  width: 137px !important;
}
.first-col {
  padding-left: 190px !important;
}
.first-col2 {
  padding-left: 190px !important;
}
.text-horario {
  background-color: white !important;
  padding: 15px;
  font-size: 16px !important;
}
.border-rosado:hover {
  background-color: white !important;
  cursor: no-drop !important;
}
.border-rosado {
  color: rgb(255, 71, 157, 0.7) !important;
  border: none !important;
  font-size: 14px !important;
}
.border-verde:hover {
  color: rgb(1, 161, 1) !important;
  border: 1.2px solid rgb(24, 211, 24) !important;
  background-color: rgb(219, 219, 219) !important ;
}
.border-verde {
  transition: none !important;
  color: rgb(0, 153, 0) !important;
  border: 1.2px solid rgb(24, 211, 24) !important;
}
.border-verde:focus {
  color: black !important;
  border: 1.2px solid rgb(29, 29, 29) !important;
  background-color: rgb(24, 211, 24) !important ;
}
.activaBtnVerde {
  color: black !important;
  border: 1.2px solid rgb(29, 29, 29) !important;
  background-color: rgb(24, 211, 24) !important ;
}
.btn-outline-secondary:focus {
  box-shadow: none !important;
}

.btn:disabled {
  opacity: 1 !important;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active {
  background-color: #2c6100 !important;
  border-color: #2c6100 !important;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #2c6100;
  border-color: #2c6100;
}
.card22 {
  border-radius: 20px !important;
  width: 110px;
  height: 105px;
}

@media only screen and (max-width: 426px) {
  .static {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 16px !important;
    padding-bottom: 16px !important;
    width: 40% !important;
  }
  .card22 {
    border-radius: 10px !important;
    width: 90px;
    height: 85px;
  }
  table {
    padding: 0;
  }
  .p0 {
    padding: 0 !important;
  }
  .nopadding {
    padding: 0.5rem !important;
  }
  .text-horario {
    font-size: 14px !important;
  }
  .first-col {
    padding-left: 170px !important;
  }
  .first-col2 {
    padding-left: 170px !important;
  }
  .border-rosado {
    font-size: 12 px !important;
  }
  .border-verde {
    font-size: 14px !important;
  }
}
@media only screen and (max-width: 375px) {
  .border-rosado {
    font-size: 10px !important;
  }
  .border-verde {
    font-size: 13px !important;
  }
  .text-horario {
    font-size: 11px !important;
  }
  .first-col {
    padding-left: 130px !important;
  }
  .first-col2 {
    padding-left: 130px !important;
  }
  @media only screen and (max-width: 330px) {
    .border-rosado {
      font-size: 9px !important;
    }
    .border-verde {
      font-size: 11px !important;
    }
    .text-horario {
      font-size: 11px !important;
    }
    .first-col {
      padding-left: 100px !important;
    }
    .first-col2 {
      padding-left: 100px !important;
    }
  }
}
</style>
